/**
 * JavaScript Graphical User Interface Object Library
 * GUI.Popup namespace
 *
 * @author Ilya Zharovsky
 * @copyright JsGui
 * @namespace GUI.Popup
 */

GUI.Popup = {};